'use client';

import { alpha, Box, Card, CardContent, Skeleton } from '@mui/material';

import { PALETTE_KEYS } from '@/constants';

export const ProfitLossCardSkeleton = () => {
  return (
    <Card
      sx={{
        bgcolor: PALETTE_KEYS.BACKGROUND_PAPER,
        borderRadius: 4,
        border: '1px solid',
        borderColor: PALETTE_KEYS.DIVIDER,
        height: '100%',
        minHeight: 280,
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: 4 }}>
        <Box
          sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}
        >
          <Box>
            <Skeleton
              variant="text"
              width={120}
              height={40}
              sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1), mb: 0.5 }}
            />
            <Skeleton
              variant="text"
              width={80}
              height={20}
              sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width={40}
                height={28}
                sx={{
                  borderRadius: 1.5,
                  bgcolor: (theme) => alpha(theme.palette.text.primary, 0.05),
                }}
              />
            ))}
          </Box>
        </Box>

        {/* Chart Area Skeleton */}
        <Box sx={{ height: 160, display: 'flex', alignItems: 'flex-end', gap: 1, px: 1 }}>
          {[40, 70, 45, 90, 65, 30, 85, 50, 75, 40, 60, 80].map((h, i) => (
            <Skeleton
              key={i}
              variant="rectangular"
              width="100%"
              height={`${h}%`}
              sx={{
                borderRadius: '4px 4px 0 0',
                bgcolor: (theme) => alpha(theme.palette.text.primary, 0.05),
                flex: 1,
              }}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProfitLossCardSkeleton;
